import dateFormat from 'date-fns/format'

export const formatDate = (value, pattern) => {
    if (value === null || value === undefined || value === '') return ''
    const date = new Date(value)
    return Number.isNaN(date.getTime()) ? '' : dateFormat(date, pattern)
}
